import React, { useContext, useEffect, useRef, useState } from "react";
import { useParams, useRouteMatch, useLocation, useNavigate } from "react-router-dom";
import { InputText } from "primereact/inputtext";
import { Button, Col, Container, Row, Image, InputGroup, Form } from "react-bootstrap";
import { Toast } from "primereact/toast";
import logoLight from "../../../assets/img/logo/main-logo-light.svg";
import logoDark from "../../../assets/img/logo/main-logo-dark.svg";
import { ThemeContext } from "../../../context/theme-context";
import { Card } from "primereact/card";
import "./resetPassword.scss";
import { IconField } from 'primereact/iconfield';
import { InputIcon } from 'primereact/inputicon';
import Footer from "../../../components/footer/footer";
import { Password } from 'primereact/password';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye, faEyeSlash, faKeySkeleton } from "@fortawesome/pro-solid-svg-icons";
import { MainApi } from "../../../services/authentication/api";
import { Configuration } from "../../../services/authentication/configuration";
import JSEncrypt from "jsencrypt";


const MetKey = `-----BEGIN PUBLIC KEY-----
MIIBITANBgkqhkiG9w0BAQEFAAOCAQ4AMIIBCQKCAQB3prLK5rWvXhOfC8JyMImg
NWH1XaY8+pQGs5FVy0dAPcogNi7FJKQvjNOx2nNl4ESU1ShT3TNe69L8x45MR2zg
OGbgN1NXdCCYu7bsJlQUxWuu1jEqZVl5PKgz8JSrkk47kRUFHw2Ogb50nYhR9X0q
LaU+UZshu5UG/ut/gaSS8TStrHwGifYsVRJIytSldEWlUWtuh19dc7RHVhwd3nd5
lBqqJC3cy2va2rRjC0f/UwHCANfvOPMT1Kfe+9ygihQ8l9B199+kgzy1Z/loBRsr
mVttnyKF9qvjzXbk5ZaFznyAFOu0pdLf3Wqp0X7YPFV7K2tqBoLJACUpH2NSUDej
AgMBAAE=
-----END PUBLIC KEY-----`;

const ResetPasswordFromMail = () => {
    const navigate = useNavigate();
    const currentTheme = useContext(ThemeContext).theme;
    const logo = currentTheme === "dark" ? logoDark : logoLight;
    const encrypt = new JSEncrypt();
    encrypt.setPublicKey(MetKey);
    const location = useLocation();
    const mainApi = new MainApi(new Configuration({ basePath: process.env.REACT_APP_AUTHENTICATION_API_BASE_PATH }));
    const { fp } = useParams();
    const toast = useRef(null);
    const [password, setPassword] = useState("");
    const [passwordAgain, setPasswordAgain] = useState("");
    const [isShowPassword, setIsShowPassword] = useState(false);
    const [isShowPasswordAgain, setIsShowPasswordAgain] = useState(false);
    const queryString = location.pathname.split('?')[1];
    const passwordHandleChange = (e) => {
        setPassword(e.target.value);
    }

    const passwordAgainHandleChange = (e) => {
        setPasswordAgain(e.target.value);
    }

    const handleMouseDownPassword = () => {
        setIsShowPassword(true);
    };

    const handleMouseUpPassword = () => {
        setIsShowPassword(false);
    };

    const handleMouseDownPasswordAgain = () => {
        setIsShowPasswordAgain(true);
    }

    const handleMouseUpPasswordAgain = () => {
        setIsShowPasswordAgain(false);
    }


    const clickLogo = () => {
        navigate('/auth/login');
    }



    //#region API CALLS 

    const resetPassword = () => {
        
        const currentPath = window.location.search;
        const queryString = currentPath.split('fp=')[1];
        if (!queryString) {
            toast.current.show({ severity: 'error', summary: 'Hata', detail: 'Şifre sıfırlama bağlantısı hatalı', life: 3000 });
            return;
        }

        else if (!password || !passwordAgain) {
            toast.current.show({ severity: 'error', summary: 'Hata', detail: 'Şifre alanları boş olamaz', life: 3000 });
            return;
        }

        else if (password.length < 6 || passwordAgain.length < 6) {
            toast.current.show({ severity: 'error', summary: 'Hata', detail: 'Şifre en az 6 karakter olmalıdır', life: 3000 });
            return;
        }

        else if (password !== passwordAgain) {
            toast.current.show({ severity: 'error', summary: 'Hata', detail: 'Şifreler uyuşmuyor', life: 3000 });
            return;
        }

        const encryptPassword = encrypt.encrypt(password);
        mainApi.apiMainResetPasswordEndGet(queryString, encryptPassword).then((response) => {
            if (response.data === 'Bad') {
                toast.current.show({ severity: 'error', summary: 'Hata', detail: 'Şifre sıfırlanırken bir hata oluştu', life: 3000 });
            }
            else {
                toast.current.show({ severity: 'success', summary: 'Şifreniz başarıyla sıfırlandı', detail: 'Giriş ekranına yönlendiriliyorsunuz...', life: 3000 });
                setTimeout(() => {
                    navigate('/auth/login?UyeGirisi');
                }, 2000);
            }
        }).catch((error) => {
            toast.current.show({ severity: 'error', summary: 'Hata', detail: 'Şifre sıfırlanırken bir hata oluştu', life: 3000 });
        });
    }

    //#endregion API CALLS

    return (
        <div className="password-reset-page">
            <Toast ref={toast} position="bottom-right" />
            <Container className="header-container">
                <Row className="header-container-row">
                    <Col>
                        <Image src={logo} fluid onClick={clickLogo} />
                    </Col>
                </Row>
            </Container>

            <Container className="password-reset-container">

                <Card title="Şifrenizi Sıfırlayınız" className="m-t-10 card" >

                    <Row>
                        <Col>

                            <InputGroup className="user-password-input-group w-100">
                                <InputGroup.Text id="inputGroup-sizing-default" className="p-5">
                                    <FontAwesomeIcon icon={faKeySkeleton} className="userLoginKeyIcon" />
                                </InputGroup.Text>
                                <Form.Control className="userLoginPassword customRegisterInput"
                                    value={password}
                                    onChange={(e) => { setPassword(e.target.value) }}
                                    type={isShowPassword ? "text" : "password"}
                                    aria-label="Default" aria-describedby="inputGroup-sizing-default" placeholder="Şifre" name="password" />
                                <InputGroup.Text id="inputGroup-sizing-default" className="userLoginEyeIcon"
                                    onMouseDown={handleMouseDownPassword}
                                    onMouseUp={handleMouseUpPassword}
                                    onMouseLeave={handleMouseUpPassword}
                                >
                                    <FontAwesomeIcon icon={isShowPassword ? faEye : faEyeSlash} />
                                </InputGroup.Text>
                            </InputGroup>

                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            <InputGroup className="user-password-input-group w-100">
                                <InputGroup.Text id="inputGroup-sizing-default" className="p-5">
                                    <FontAwesomeIcon icon={faKeySkeleton} className="userLoginKeyIcon" />
                                </InputGroup.Text>
                                <Form.Control className="userLoginPassword customRegisterInput"
                                    value={passwordAgain}
                                    onChange={(e) => { setPasswordAgain(e.target.value) }}
                                    type={isShowPasswordAgain ? "text" : "password"}
                                    aria-label="Default" aria-describedby="inputGroup-sizing-default" placeholder="Şifre tekrar" name="password1" />
                                <InputGroup.Text id="inputGroup-sizing-default" className="userLoginEyeIcon"
                                    onMouseDown={handleMouseDownPasswordAgain}
                                    onMouseUp={handleMouseUpPasswordAgain}
                                    onMouseLeave={handleMouseUpPasswordAgain}
                                >
                                    <FontAwesomeIcon icon={isShowPasswordAgain ? faEye : faEyeSlash} />
                                </InputGroup.Text>
                            </InputGroup>
                        </Col>
                    </Row>

                    <Row>
                        <Col>
                            <Button className="reset-button m-t-10" onClick={resetPassword}>
                                Sıfırla
                            </Button>
                        </Col>
                    </Row>

                </Card>


            </Container>

            <Container className="footer-container">
                <Footer />

            </Container>


        </div >
    )
}

export default ResetPasswordFromMail;

